import { IDefaultElement, buildCustomExpressionValue } from "core";
import { UntransformedColorFieldConfig } from "../types";

export const defaultElement: IDefaultElement<UntransformedColorFieldConfig> = {
  config: {
    value: buildCustomExpressionValue('"#FFF"'),
  },
};
